const FIELD_RULES = {
  title: { min: 8, max: 200 },
  primary_hook: { min: 10, max: 300 },
  angle: { min: 20, max: 600 },
  audience: { min: 10, max: 600 },
  thesis: { min: 30, max: 1200 },
};

const VALID_OBJECTIVES = new Set(['awareness', 'education', 'monetizing']);

function normalized(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function lengthIssue(value, { min, max }) {
  const text = normalized(value);
  if (!text) return { key: 'masterProject.detail.validation.required' };
  if (text.length < min) return { key: 'masterProject.detail.validation.tooShort', values: { min } };
  if (text.length > max) return { key: 'masterProject.detail.validation.tooLong', values: { max } };
  return null;
}

export function validateMasterContentForm(form) {
  const issues = {};

  Object.entries(FIELD_RULES).forEach(([field, rule]) => {
    const issue = lengthIssue(form?.[field], rule);
    if (issue) issues[field] = issue;
  });

  if (!normalized(form?.body_markdown)) {
    issues.body_markdown = { key: 'masterProject.detail.validation.required' };
  }

  if (!VALID_OBJECTIVES.has(form?.objective)) {
    issues.objective = { key: 'masterProject.detail.validation.invalidObjective' };
  }

  const cta = normalized(form?.cta);
  if (form?.objective === 'monetizing' && !cta) {
    issues.cta = { key: 'masterProject.detail.validation.ctaRequired' };
  } else if (cta.length > 0 && cta.length < 5) {
    issues.cta = { key: 'masterProject.detail.validation.tooShort', values: { min: 5 } };
  } else if (cta.length > 600) {
    issues.cta = { key: 'masterProject.detail.validation.tooLong', values: { max: 600 } };
  }

  return issues;
}

export function isMasterContentFormValid(form) {
  return Object.keys(validateMasterContentForm(form)).length === 0;
}

export const MASTER_CONTENT_FIELD_LIMITS = {
  ...FIELD_RULES,
  cta: { min: 5, max: 600 },
};
